var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-form",
        [
          _c(
            "v-container",
            [
              !_vm.actividadExtendida
                ? _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { md12: "", row: "" } }, [
                        _c("p", { staticClass: "centrado" }, [
                          _vm._v("Sin actividades extendidas")
                        ])
                      ])
                    ],
                    1
                  )
                : _vm.actividadExtendida.dispositivos.length > 0
                ? _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { md12: "", row: "" } }, [
                        _c("p", [_vm._v(_vm._s(_vm.actividadExtendida.nombre))])
                      ]),
                      _vm._l(_vm.actividadExtendida.dispositivos, function(
                        dispositivo
                      ) {
                        return _c(
                          "v-flex",
                          {
                            key: dispositivo.descripcion,
                            attrs: { md3: "", xs6: "" }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(dispositivo.descripcion) + ":")
                            ]),
                            _vm._v(
                              "\n          " +
                                _vm._s(dispositivo.valor) +
                                "\n        "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { md12: "", row: "" } }, [
                        _c("p", { staticClass: "centrado" }, [
                          _vm._v(
                            "\n            Detalle de actividad extendida no disponible\n          "
                          )
                        ])
                      ])
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }